import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchStockUpdate } from '../../../../../../../../../../redux/features/dashboard';
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';

const UpdateStockForm = ({ platforms, stockRecostock, onClose }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formValues, setFormValues] = useState({});

    const handleChange = (platformName, field, value) => {
        setFormValues({
            ...formValues,
            [platformName]: {
                ...formValues[platformName],
                [field]: value,
            },
        });
    };

    const handleUpdateStock = async (e) => {
        e.preventDefault();
        if (isLoading) return;
        setIsLoading(true);

        const newData = platforms.map((platf) => {
            const stock = Number(formValues[platf.nombre]?.stock || 0);
            const aumento = formValues[platf.nombre]?.aumento || '';
            const ratio =
                stockRecostock > 0
                    ? ((stock * 100) / stockRecostock).toFixed(2)
                    : 0;

            return {
                ...platf,
                stock_plataforma: stock,
                aumento_plataforma: aumento,
                diferencia: stockRecostock - stock,
                ratio,
            };
        });

        const isUpdated = await dispatch(fetchStockUpdate(newData));
        setIsLoading(false);

        if (isUpdated) {
            toast.success('Stock y aumentos actualizados correctamente!');
            onClose();
        }
    };

    useEffect(() => {
        const initial = {};
        platforms.forEach((platf) => {
            initial[platf.nombre] = {
                stock: platf.stock_plataforma || 0,
                aumento: platf.aumento_plataforma || '',
            };
        });
        setFormValues(initial);
    }, [platforms]);

    return (
        <div className="update-rf-form">
            <form className="form col-12">
                {platforms.map((platf) => {
                    return (
                        <div className="form-group" key={platf.nombre}>
                            <label>{platf.nombre}: </label>
                            <div className="d-flex gap-2 w-100">
                                <input
                                    type="number"
                                    placeholder="Stock"
                                    className='w-50'
                                    value={
                                        formValues[platf.nombre]?.stock || ''
                                    }
                                    onChange={(e) =>
                                        handleChange(
                                            platf.nombre,
                                            'stock',
                                            e.target.value
                                        )
                                    }
                                />
                                <input
                                    type="text"
                                    placeholder="Aumento"
                                    className='w-50'
                                    value={
                                        formValues[platf.nombre]?.aumento || ''
                                    }
                                    onChange={(e) =>
                                        handleChange(
                                            platf.nombre,
                                            'aumento',
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                        </div>
                    );
                })}
                <div className="w-100 d-flex align-items-end justify-content-end">
                    <button
                        style={{ width: '120px', height: '42px' }}
                        className="btn btn-primary"
                        onClick={handleUpdateStock}
                    >
                        {isLoading ? (
                            <CircularProgress color="inherit" size={17} />
                        ) : (
                            'Guardar'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UpdateStockForm;
